import React from 'react';
import { ArrowUpRightIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { contact, hours } from '../data/site';
export function VisitSection() {
  return <section id="infos" aria-labelledby="infos-title" className="w-full bg-forest-800 py-24 lg:py-32" data-id="element-120" data-mp="24c50q6om5oq2">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-121" data-mp="1zdbki6hxzjm7">
        <h2 id="infos-title" className="font-serif text-5xl font-light leading-none text-cream-50 md:text-8xl" data-id="element-122" data-mp="1zbh14wmbjzk8">
          Venez nous voir
        </h2>

        <div className="mt-16 grid gap-14 lg:grid-cols-12" data-id="element-123" data-mp="28e9r8wjrm58h">
          <div className="lg:col-span-6" data-id="element-124" data-mp="28bnl91civxsd">
            <p className="text-sm text-cream-100/60" data-id="element-125" data-mp="2n35v0hesgw3a">Réservations</p>
            <a href={contact.phoneHref} className="mt-2 block whitespace-nowrap font-serif text-5xl text-cream-50 transition-colors duration-150 hover:text-ember-400 md:text-6xl" data-id="element-126" data-mp="2n4gz6ic5c5ux">
              {contact.phone}
            </a>
            <p className="mt-4 max-w-md leading-relaxed text-cream-100/70" data-id="element-127" data-mp="2s3agkluk0h0d">
              Le plus simple, c’est d’appeler. Pour les groupes et privatisations, écrivez-nous.
            </p>

            <ul className="mt-10 space-y-4 text-cream-100/85" data-id="element-128" data-mp="8ywyrqz6xuh8">
              <li className="flex items-center gap-3" data-id="element-129" data-mp="dwp1lg1dj107">
                <PhoneIcon className="h-4 w-4 text-ember-400" aria-hidden="true" data-id="element-130" data-mp="dvx7k9nfdbc1" />
                <a href={contact.phoneHref} className="hover:text-cream-50" data-id="element-131" data-mp="ixwa5hbcc47x">{contact.phone}</a>
              </li>
              <li className="flex items-center gap-3" data-id="element-132" data-mp="nv5x8qb9c3sl">
                <MailIcon className="h-4 w-4 text-ember-400" aria-hidden="true" data-id="element-133" data-mp="rw7xnagwulw5" />
                <a href={`mailto:${contact.email}`} className="hover:text-cream-50" data-id="element-134" data-mp="wnzrpuz9z9r1">{contact.email}</a>
              </li>
              <li className="flex items-center gap-3" data-id="element-135" data-mp="11n2mmmljjzla">
                <MapPinIcon className="h-4 w-4 text-ember-400" aria-hidden="true" data-id="element-136" data-mp="11onda14qiydv" />
                <a href={contact.mapHref} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 hover:text-cream-50" data-id="element-137" data-mp="16jsyexqbc90w">
                  {contact.city}, {contact.region}
                  <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-138" data-mp="gzbed4x6jp4h" />
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-5 lg:col-start-8" data-id="element-139" data-mp="qvxujgek9s06">
            <p className="text-sm text-cream-100/60" data-id="element-140" data-mp="qud5g6b0n19p">Horaires</p>
            <dl className="mt-4 divide-y divide-cream-100/10 border-y border-cream-100/10" data-id="element-141" data-mp="14mjk1nyit071">
              {hours.map(h => <div key={h.days} className="flex items-baseline justify-between gap-6 py-4" data-id="element-142" data-mp="znq3fmnxst2n">
                  <dt className="font-serif text-2xl text-cream-50" data-id="element-143" data-mp="1ek7bo50txrkz">{h.days}</dt>
                  <dd className={`text-right text-sm ${h.time === 'Fermé' ? 'text-cream-100/45' : 'text-cream-100/85'}`} data-id="element-144" data-mp="19ngzvtw25i5d">
                    {h.time}
                  </dd>
                </div>)}
            </dl>
            <p className="mt-4 text-xs text-cream-100/50" data-id="element-145" data-mp="3bfdcz7xvj029">Horaires variables selon la saison — un coup de fil pour être sûr.</p>
          </div>
        </div>
      </div>
    </section>;
}